module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.product.title
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.product.original.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.product.original.status).label))]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.variations[0].images[0],
      "alt": _vm.product.title
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('span', {
    staticClass: "divider"
  }, [_vm._v("Conta")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Nome:")]), _vm._v(" " + _vm._s(_vm.account.name))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Nickname:")]), _vm._v(" " + _vm._s(_vm.account.nickname))]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("Atributos")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Condição:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.$t(("mercadoLivre.conditions." + (_vm.product.condition) + ".label")))))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Marca:")]), _vm._v(" " + _vm._s(_vm._f("attribute")((_vm.getAttributeValue('BRAND')) ? _vm.getAttributeValue('BRAND') : _vm.product.brand)))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Tipo:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.$t(("mercadoLivre.types." + (_vm.product.type) + ".label")))))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Envio:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.$t(("mercadoLivre.shippingOptions." + (_vm.product.shippingMode) + ".label")))))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Quantidade de variações:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.product.variations.length)))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb83adc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/report/Product.vue
// module id = 3479
// module chunks = 0